import Api from 'app/services/Api';

const resource = 'auth';

export function login(payload) {
  return Api.post(`${resource}/login`, payload);
}
